export default __webpack_public_path__ + "static/media/tandem-studio-recordplayer.2569b2f0.jpg";